import { client } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleClientMethod } from "../client";

export interface CreateOrderInput {
  quoteId?: string;
  title: string;
  description?: string;
  fulfillmentType?: "delivery" | "pickup";
  notes?: string;
  expectedDeliveryDate?: string;
  products?: Array<{
    productId: string;
    hajocaProductId?: string;
    description?: string;
    quantity: number;
    unitPrice?: number;
    notes?: string;
  }>;
}

export const useCreateOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateOrderInput) => {
      return await handleClientMethod(
        client.POST("/api/orders", {
          body: data,
        })
      );
    },
    onSuccess: (newOrder) => {
      // Invalidate orders list to refetch
      queryClient.invalidateQueries({ queryKey: ["/api/orders"] });
      // Optionally set the new order in cache
      if (newOrder?.uid) {
        queryClient.setQueryData(["/api/orders", newOrder.uid], newOrder);
      }
    },
  });
};
